export default __webpack_public_path__ + "static/media/regulatory--give-way-to-bicycles--g1.c339dedb.png";